import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo, useState } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Blog } from "../../types"
import { initialValuesBlog, validationSchemaBlog } from "./BlogCommon"
import BlogForm from "./BlogForm"
import { useDeleteBlog, usePartialUpdateBlog, useBlog, useUpdateBlog } from "../../hooks/blog"
import BlogEditorForm from "./BlogEditorForm"

export default function BlogUpdate() {
  const updateBlog = useUpdateBlog()
  const updatePartialBlog = usePartialUpdateBlog()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: blog } = useBlog(Number(id))

  const deleteBlog = useDeleteBlog()

  const [modalStateDeleteBlog, modalActionsDeleteBlog] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesBlog(blog), [blog])
  const validationSchema = useMemo(() => validationSchemaBlog(), [])

  const [activeTab, setActiveTab] = useState("dettaglio")

  useBreadcrumbs([{ label: "Blog", href: "/blog/blog" }, { label: "Dettaglio Post" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{blog?.title}</H1>
          {activeTab === "dettaglio" && (
            <Button
              size="md"
              variant="danger"
              title="Elimina"
              leadingIcon="delete"
              onClick={() => {
                modalActionsDeleteBlog.open()
              }}
            />
          )}
        </Flex>
        <ScrollLayout.Tabs
          className="mt-6"
          onTabChange={(tab) => {
            setActiveTab(tab)
          }}
          initialTab="dettaglio"
        >
          <ScrollLayout.Tab id="dettaglio" label="Dettaglio" key={"dettaglio"}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                if (typeof values.cover === "string") {
                  delete values.cover
                }
                return updateBlog.mutateAsync(values as Blog).then(() => {
                  navigate(`/blog/blog`)
                })
              }}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                    <BlogForm />
                  </Container>
                  <BottomFormFixed url="/blog/blog" />
                </form>
              )}
            </Formik>
          </ScrollLayout.Tab>
          <ScrollLayout.Tab id="contenuti" label="Contenuti" key={"contenuti"}>
            <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
              <BlogEditorForm
                fieldName="data"
                onSave={(d) => {
                  updatePartialBlog.mutate({
                    id: Number(id),
                    data: d,
                  })
                }}
                currentValue={blog?.data || []}
              />
            </Container>
          </ScrollLayout.Tab>
        </ScrollLayout.Tabs>
      </ScrollLayout>

      <ModalDelete
        isOpen={modalStateDeleteBlog.isOpen}
        onClose={modalActionsDeleteBlog.close}
        onDelete={() => {
          return deleteBlog.mutateAsync(blog?.id).then(() => {
            navigate(`/blog/blog`)
          })
        }}
        message="Sei sicuro di voler eliminare il post?"
        title="Elimina Post"
      />
    </Layout>
  )
}
